import { render } from "./RecipeArticles.vue?vue&type=template&id=56c85a3b"
import script from "./RecipeArticles.vue?vue&type=script&lang=js"
export * from "./RecipeArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__